import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-status-badge',
  templateUrl: './sms-status-badge.component.html',
  styleUrls: ['./sms-status-badge.component.css']
})
export class SmsStatusBadgeComponent implements OnInit {

  @Input() value: string;
  constructor() { }

  ngOnInit(): void {
  }

}
